import { GALLERY } from './actionTypes';
import { actionCreator } from '../actions/index';
import { FormInterface } from '../Interfaces/Forms/FormsInterface';

export const selectGalleryForm = actionCreator<FormInterface['ref']>(GALLERY.SELECT_FORM);
